import { createModifiersFactory } from './modifier';

import type { ModificationsList, Modifier } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export function generateRemovals(params: Params): Modifier[] {
  const { initialModifications, activeModifications } = params;

  const generateModificationChanges = createModifiersFactory(activeModifications); // prettier-ignore
  const modificationChanges = initialModifications.flatMap(generateModificationChanges); // prettier-ignore

  return modificationChanges.filter(Boolean) as Modifier[];
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  initialModifications: ModificationsList;
  activeModifications: ModificationsList;
};
